module.exports = __webpack_public_path__ + "5aadcab7eb2706ca30a6707812a23e42.pdf";